module Meevo.Plugins.AppointmentBook {
    class MissedOpportunityController {
        protected securityKeys = Meevo.Components.Common.SecurityKeys;
        protected model : any;
        startTimeTemp: any;
        endTimeTemp: any;
        employeeCriteria: any;
        serviceCriteria: any;
        timeSelections = {};

        static $inject = [
            "$mdDialog", "meevo.components.common.DataService", "meevo.components.modal.ModalService", "actionService", "startingModel", "$filter", "$translate"
        ];
        
        constructor(private $mdDialog,
            protected dataService: Meevo.Components.BaseClasses.IDataService,
            protected modalService: Meevo.Components.Modal.IModalService,
            protected actionService: any,
            private startingModel: any,
            private $filter: angular.IFilterService,
            private $translate: angular.translate.ITranslateService) {
            this.startTimeTemp = {
                value: moment("09:00", "HH:mm").toDate()
            };
            this.model = startingModel ? startingModel : {
                startDate: moment().toDate()
            }
            this.employeeCriteria = { showEmployeesOnly: true };
            this.serviceCriteria = { wildCardType: Model.FilterWildcardType.Contains };
            this.setTimeIntervalsByTimeFormat();
        }

        genderPreferenceExclusionList = [Model.EmployeeGenderSearchEnum.RandomEmployee, Model.EmployeeGenderSearchEnum.SpecificEmployee];

        save(isValid) {
            if (isValid) {
                this.model.startTime = moment(this.startTimeTemp.value).format("HH:mm:ss.SSSSSSS");
                this.model.endTime = this.endTimeTemp ? moment(this.endTimeTemp.value).format("HH:mm:ss.SSSSSSS") : undefined;
                if (this.model.startTimeType == Model.ScanTimeTypeEnum.Custom && this.model.startTime > this.model.endTime) {
                    this.modalService.alert("MESSAGE_END_TIME_GREATER_START_TIME");
                    return;
                }
                this.model.serviceId = this.model.service.id;
                this.model.clientId = this.model.client?this.model.client.id:null;
                this.dataService.add("missedOpportunity", this.model)
                    .then(() => {
                        this.$mdDialog.hide();
                    });
            }
        }

        cancel() {
            this.$mdDialog.hide();
        }

        serviceChanged() {
            if (this.model.service) {
                this.employeeCriteria = { showEmployeesOnly: true, serviceIdList: [this.model.service.id] };
            } else {
                this.employeeCriteria = { showEmployeesOnly: true };
            }
        }

        employeeChanged() {
            this.model.employeeId = this.model.employee ? this.model.employee.id : undefined;
            if (this.model.employeeId) {
                this.model.genderPreference = null;
            }
        }

        clientChanged(changeType: string) {
            if (changeType === "ClientType") {
                if (this.model.clientType && this.model.clientType != Model.ClientTypeEnum.Client) {
                    //anon changed
                    this.model.client = {
                        id: undefined,
                        clientType: this.model.clientType,
                        displayName: Model.ClientTypeEnum[this.model.clientType].replace("Anonymous", "Anonymous ")
                    }
                    this.model.clientId = undefined;
                }
            } else if (isObject(this.model.client)) {
                if (this.model.client) {
                    this.model.clientId = this.model.client.id;
                    this.model.clientType = Model.ClientTypeEnum.Client;
                }
            }
        }

        genderPreferenceChanged() {
            this.dataService.getEnumList(Meevo.Model.EnumTypeEnum.EmployeeGenderSearchEnum)
                .then((data: any) => {
                    // Hack: at runtime, genderPreference coming in as  a string not finding object in list.  Have to manually convert to int.
                    let genderPreference: any = this.model.genderPreference;
                    genderPreference = parseInt(genderPreference);
                    let selectedGenderPreference: any = _.findWhere(data, { id: genderPreference });
                    if (selectedGenderPreference) {
                        this.model.employeeId = undefined;
                        this.model.employee = {
                            id: undefined,
                            displayName: selectedGenderPreference.displayName
                        }
                    }
                });
        }

        preAddEditClient() {
            this.actionService.addMissedOpportunityPreAddEditClient();
        }

        setTimeIntervalsByTimeFormat() {
            let dateFilter = this.$filter("date");
            let timeNoon = dateFilter(moment('12:00', 'HH:mm').toDate(), "shortTime");
            let someEvening = dateFilter(moment('17:00', 'HH:mm').toDate(), "shortTime");
            let timeParams = { TimeNoon: timeNoon, TimeEvening: someEvening };
            this.timeSelections = [
                { id: Model.ScanTimeTypeEnum.Morning, value: this.$translate.instant("LABEL_MORNING_WITH_TIME", timeParams) },
                { id: Model.ScanTimeTypeEnum.Afternoon, value: this.$translate.instant("LABEL_AFTERNOON_WITH_TIME", timeParams) },
                { id: Model.ScanTimeTypeEnum.Evening, value: this.$translate.instant("LABEL_EVENING_WITH_TIME", timeParams) },
                { id: Model.ScanTimeTypeEnum.Custom, value: this.$translate.instant("LABEL_BETWEEN") }
            ];
        }
    }

    angular.module("ApptBookApp").controller("meevo.plugins.appointmentbook.MissedOpportunityController", MissedOpportunityController);
}